const text = (value) => (value == null ? '' : String(value).trim());

export const getCalendarStaffOptions = (groupedOptions = [], staffRecords = []) => {
  const staffGroup = Array.isArray(groupedOptions)
    ? groupedOptions.find((group) => group?.label === 'Staff')
    : null;
  const records = Array.isArray(staffRecords) ? staffRecords : [staffRecords];
  const recordsById = new Map(records
    .filter((staff) => staff && staff.id != null)
    .map((staff) => [String(staff.id), staff]));
  return (staffGroup?.options || [])
    .filter((option) => option?.optionType === 'staff' && option.value !== 'all_staff')
    .map((option) => ({ ...recordsById.get(String(option.value)), ...option }));
};

export const getCalendarDisplayName = (item = {}) => {
  const firstName = text(item.first_name);
  const lastName = text(item.last_name);
  return [firstName, lastName].filter(Boolean).join(' ') || text(item.resource_item) || text(item.label);
};

export const getCalendarAppointmentTitle = ({
  client,
  booking_type,
  widget_first_name,
  widget_last_name,
} = {}) => {
  const widgetFirstName = text(widget_first_name);
  const widgetLastName = text(widget_last_name);
  if (booking_type === 'Widget' && widgetFirstName && widgetLastName) {
    return `${widgetFirstName} ${widgetLastName}`;
  }
  return getCalendarDisplayName(client || {});
};

export const getCalendarInitials = (item = {}) => {
  const firstName = text(item.first_name);
  const lastName = text(item.last_name);
  if (firstName || lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`;
  }
  return getCalendarDisplayName(item).charAt(0);
};

/**
 * Join a person's name parts without leaking the literal string "undefined".
 *
 * Appointment payloads can be partial while detail data is (re)loading, so
 * `staff.first_name + " " + staff.last_name` renders "Undefined undefined".
 * Only present parts are joined; a person with no name yields "".
 */
export const getCalendarPersonName = (item = {}) => {
  const firstName = text(item?.first_name);
  const lastName = text(item?.last_name);
  return [firstName, lastName].filter(Boolean).join(' ');
};
